import { createSelector } from "@reduxjs/toolkit"
import { DeviceSelector } from "../device/selector"
import { selectAuthUser } from "../../pages/sign-in/selector"

function getExpiryDays(paymentExpiryDate:string) {
    if(!paymentExpiryDate) return 0;

    const expiryDate = new Date(paymentExpiryDate);
    if (Number.isNaN(expiryDate.getTime())) return 0;

    const currentDate = new Date();
    const differenceInMs = expiryDate.getTime() - currentDate.getTime();
    const daysUntilExpiry = Math.ceil(differenceInMs / (1000 * 60 * 60 * 24));

    const isSameOrFutureCalendarDay =
        expiryDate.getFullYear() > currentDate.getFullYear() ||
        (expiryDate.getFullYear() === currentDate.getFullYear() &&
            (expiryDate.getMonth() > currentDate.getMonth() ||
                (expiryDate.getMonth() === currentDate.getMonth() &&
                    expiryDate.getDate() >= currentDate.getDate())));

    if (isSameOrFutureCalendarDay) {
        return Math.max(1, daysUntilExpiry);
    }

    return Math.max(0, daysUntilExpiry);
}
  

export const UserProfileMenuSelector = createSelector(
    [selectAuthUser, DeviceSelector],
    (user, device) => {
        const expiryIn = getExpiryDays(user.paymentExpiryDate);
        const updatedAuthUser = { ...user, expiryIn, img: user?.profile?.img }
        return { authUser: updatedAuthUser, device }
    }
)